interface LineSegment {
  start: [number, number];
  end: [number, number];
}

interface VectorCharacter {
  segments: LineSegment[];
  width: number;
}

interface VectorFont {
  characters: Map<string, VectorCharacter>;
  height: number;
  spacing: number;
}

const FONT_HEIGHT = 7;
const FONT_SPACING = 1;

const createCharacterMap = (): Map<string, VectorCharacter> => {
  const map = new Map<string, VectorCharacter>();

  // A
  map.set("A", {
    segments: [
      { start: [0, 7], end: [0, 2] },
      { start: [0, 2], end: [2, 0] },
      { start: [2, 0], end: [4, 2] },
      { start: [4, 2], end: [4, 7] },
      { start: [0, 4], end: [4, 4] },
    ],
    width: 5,
  });

  // B
  map.set("B", {
    segments: [
      { start: [0, 0], end: [0, 7] },
      { start: [0, 0], end: [3, 0] },
      { start: [3, 0], end: [4, 1] },
      { start: [4, 1], end: [4, 2] },
      { start: [4, 2], end: [3, 3] },
      { start: [3, 3], end: [0, 3] },
      { start: [0, 3], end: [3, 3] },
      { start: [3, 3], end: [4, 4] },
      { start: [4, 4], end: [4, 6] },
      { start: [4, 6], end: [3, 7] },
      { start: [3, 7], end: [0, 7] },
    ],
    width: 5,
  });

  // C
  map.set("C", {
    segments: [
      { start: [4, 1], end: [3, 0] },
      { start: [3, 0], end: [1, 0] },
      { start: [1, 0], end: [0, 1] },
      { start: [0, 1], end: [0, 6] },
      { start: [0, 6], end: [1, 7] },
      { start: [1, 7], end: [3, 7] },
      { start: [3, 7], end: [4, 6] },
    ],
    width: 5,
  });

  // D
  map.set("D", {
    segments: [
      { start: [0, 0], end: [0, 7] },
      { start: [0, 0], end: [3, 0] },
      { start: [3, 0], end: [4, 1] },
      { start: [4, 1], end: [4, 6] },
      { start: [4, 6], end: [3, 7] },
      { start: [3, 7], end: [0, 7] },
    ],
    width: 5,
  });

  // E
  map.set("E", {
    segments: [
      { start: [0, 0], end: [0, 7] },
      { start: [0, 0], end: [4, 0] },
      { start: [0, 3], end: [3, 3] },
      { start: [0, 7], end: [4, 7] },
    ],
    width: 5,
  });

  // F
  map.set("F", {
    segments: [
      { start: [0, 0], end: [0, 7] },
      { start: [0, 0], end: [4, 0] },
      { start: [0, 3], end: [3, 3] },
    ],
    width: 5,
  });

  // G
  map.set("G", {
    segments: [
      { start: [4, 1], end: [3, 0] },
      { start: [3, 0], end: [1, 0] },
      { start: [1, 0], end: [0, 1] },
      { start: [0, 1], end: [0, 6] },
      { start: [0, 6], end: [1, 7] },
      { start: [1, 7], end: [3, 7] },
      { start: [3, 7], end: [4, 6] },
      { start: [4, 6], end: [4, 4] },
      { start: [4, 4], end: [2, 4] },
    ],
    width: 5,
  });

  // H
  map.set("H", {
    segments: [
      { start: [0, 0], end: [0, 7] },
      { start: [4, 0], end: [4, 7] },
      { start: [0, 3], end: [4, 3] },
    ],
    width: 5,
  });

  // I
  map.set("I", {
    segments: [
      { start: [0, 0], end: [4, 0] },
      { start: [2, 0], end: [2, 7] },
      { start: [0, 7], end: [4, 7] },
    ],
    width: 5,
  });

  // J
  map.set("J", {
    segments: [
      { start: [0, 0], end: [4, 0] },
      { start: [3, 0], end: [3, 6] },
      { start: [3, 6], end: [2, 7] },
      { start: [2, 7], end: [1, 7] },
      { start: [1, 7], end: [0, 6] },
    ],
    width: 5,
  });

  // K
  map.set("K", {
    segments: [
      { start: [0, 0], end: [0, 7] },
      { start: [4, 0], end: [0, 3] },
      { start: [0, 3], end: [4, 7] },
    ],
    width: 5,
  });

  // L
  map.set("L", {
    segments: [
      { start: [0, 0], end: [0, 7] },
      { start: [0, 7], end: [4, 7] },
    ],
    width: 5,
  });

  // M
  map.set("M", {
    segments: [
      { start: [0, 7], end: [0, 0] },
      { start: [0, 0], end: [2, 2] },
      { start: [2, 2], end: [4, 0] },
      { start: [4, 0], end: [4, 7] },
    ],
    width: 5,
  });

  // N
  map.set("N", {
    segments: [
      { start: [0, 7], end: [0, 0] },
      { start: [0, 0], end: [4, 7] },
      { start: [4, 7], end: [4, 0] },
    ],
    width: 5,
  });

  // O
  map.set("O", {
    segments: [
      { start: [1, 0], end: [3, 0] },
      { start: [3, 0], end: [4, 1] },
      { start: [4, 1], end: [4, 6] },
      { start: [4, 6], end: [3, 7] },
      { start: [3, 7], end: [1, 7] },
      { start: [1, 7], end: [0, 6] },
      { start: [0, 6], end: [0, 1] },
      { start: [0, 1], end: [1, 0] },
    ],
    width: 5,
  });

  // P
  map.set("P", {
    segments: [
      { start: [0, 0], end: [0, 7] },
      { start: [0, 0], end: [3, 0] },
      { start: [3, 0], end: [4, 1] },
      { start: [4, 1], end: [4, 2] },
      { start: [4, 2], end: [3, 3] },
      { start: [3, 3], end: [0, 3] },
    ],
    width: 5,
  });

  // Q
  map.set("Q", {
    segments: [
      { start: [1, 0], end: [3, 0] },
      { start: [3, 0], end: [4, 1] },
      { start: [4, 1], end: [4, 6] },
      { start: [4, 6], end: [3, 7] },
      { start: [3, 7], end: [1, 7] },
      { start: [1, 7], end: [0, 6] },
      { start: [0, 6], end: [0, 1] },
      { start: [0, 1], end: [1, 0] },
      { start: [3, 5], end: [4, 7] },
    ],
    width: 5,
  });

  // R
  map.set("R", {
    segments: [
      { start: [0, 0], end: [0, 7] },
      { start: [0, 0], end: [3, 0] },
      { start: [3, 0], end: [4, 1] },
      { start: [4, 1], end: [4, 2] },
      { start: [4, 2], end: [3, 3] },
      { start: [3, 3], end: [0, 3] },
      { start: [3, 3], end: [4, 7] },
    ],
    width: 5,
  });

  // S
  map.set("S", {
    segments: [
      { start: [4, 1], end: [3, 0] },
      { start: [3, 0], end: [1, 0] },
      { start: [1, 0], end: [0, 1] },
      { start: [0, 1], end: [0, 2] },
      { start: [0, 2], end: [1, 3] },
      { start: [1, 3], end: [3, 3] },
      { start: [3, 3], end: [4, 4] },
      { start: [4, 4], end: [4, 6] },
      { start: [4, 6], end: [3, 7] },
      { start: [3, 7], end: [1, 7] },
      { start: [1, 7], end: [0, 6] },
    ],
    width: 5,
  });

  // T
  map.set("T", {
    segments: [
      { start: [0, 0], end: [4, 0] },
      { start: [2, 0], end: [2, 7] },
    ],
    width: 5,
  });

  // U
  map.set("U", {
    segments: [
      { start: [0, 0], end: [0, 6] },
      { start: [0, 6], end: [1, 7] },
      { start: [1, 7], end: [3, 7] },
      { start: [3, 7], end: [4, 6] },
      { start: [4, 6], end: [4, 0] },
    ],
    width: 5,
  });

  // V
  map.set("V", {
    segments: [
      { start: [0, 0], end: [2, 7] },
      { start: [2, 7], end: [4, 0] },
    ],
    width: 5,
  });

  // W
  map.set("W", {
    segments: [
      { start: [0, 0], end: [1, 7] },
      { start: [1, 7], end: [2, 5] },
      { start: [2, 5], end: [3, 7] },
      { start: [3, 7], end: [4, 0] },
    ],
    width: 5,
  });

  // X
  map.set("X", {
    segments: [
      { start: [0, 0], end: [4, 7] },
      { start: [4, 0], end: [0, 7] },
    ],
    width: 5,
  });

  // Y
  map.set("Y", {
    segments: [
      { start: [0, 0], end: [2, 3] },
      { start: [4, 0], end: [2, 3] },
      { start: [2, 3], end: [2, 7] },
    ],
    width: 5,
  });

  // Z
  map.set("Z", {
    segments: [
      { start: [0, 0], end: [4, 0] },
      { start: [4, 0], end: [0, 7] },
      { start: [0, 7], end: [4, 7] },
    ],
    width: 5,
  });

  // 0
  map.set("0", {
    segments: [
      { start: [1, 0], end: [3, 0] },
      { start: [3, 0], end: [4, 1] },
      { start: [4, 1], end: [4, 6] },
      { start: [4, 6], end: [3, 7] },
      { start: [3, 7], end: [1, 7] },
      { start: [1, 7], end: [0, 6] },
      { start: [0, 6], end: [0, 1] },
      { start: [0, 1], end: [1, 0] },
      { start: [1, 1], end: [3, 6] },
    ],
    width: 5,
  });

  // 1
  map.set("1", {
    segments: [
      { start: [1, 1], end: [2, 0] },
      { start: [2, 0], end: [2, 7] },
      { start: [0, 7], end: [4, 7] },
    ],
    width: 5,
  });

  // 2
  map.set("2", {
    segments: [
      { start: [0, 1], end: [1, 0] },
      { start: [1, 0], end: [3, 0] },
      { start: [3, 0], end: [4, 1] },
      { start: [4, 1], end: [4, 3] },
      { start: [4, 3], end: [0, 7] },
      { start: [0, 7], end: [4, 7] },
    ],
    width: 5,
  });

  // 3
  map.set("3", {
    segments: [
      { start: [0, 1], end: [1, 0] },
      { start: [1, 0], end: [3, 0] },
      { start: [3, 0], end: [4, 1] },
      { start: [4, 1], end: [4, 2] },
      { start: [4, 2], end: [3, 3] },
      { start: [3, 3], end: [2, 3] },
      { start: [2, 3], end: [3, 3] },
      { start: [3, 3], end: [4, 4] },
      { start: [4, 4], end: [4, 6] },
      { start: [4, 6], end: [3, 7] },
      { start: [3, 7], end: [1, 7] },
      { start: [1, 7], end: [0, 6] },
    ],
    width: 5,
  });

  // 4
  map.set("4", {
    segments: [
      { start: [3, 0], end: [0, 4] },
      { start: [0, 4], end: [4, 4] },
      { start: [3, 0], end: [3, 7] },
    ],
    width: 5,
  });

  // 5
  map.set("5", {
    segments: [
      { start: [4, 0], end: [0, 0] },
      { start: [0, 0], end: [0, 3] },
      { start: [0, 3], end: [3, 3] },
      { start: [3, 3], end: [4, 4] },
      { start: [4, 4], end: [4, 6] },
      { start: [4, 6], end: [3, 7] },
      { start: [3, 7], end: [1, 7] },
      { start: [1, 7], end: [0, 6] },
    ],
    width: 5,
  });

  // 6
  map.set("6", {
    segments: [
      { start: [3, 0], end: [1, 0] },
      { start: [1, 0], end: [0, 1] },
      { start: [0, 1], end: [0, 6] },
      { start: [0, 6], end: [1, 7] },
      { start: [1, 7], end: [3, 7] },
      { start: [3, 7], end: [4, 6] },
      { start: [4, 6], end: [4, 4] },
      { start: [4, 4], end: [3, 3] },
      { start: [3, 3], end: [0, 3] },
    ],
    width: 5,
  });

  // 7
  map.set("7", {
    segments: [
      { start: [0, 0], end: [4, 0] },
      { start: [4, 0], end: [2, 7] },
    ],
    width: 5,
  });

  // 8
  map.set("8", {
    segments: [
      { start: [1, 0], end: [3, 0] },
      { start: [3, 0], end: [4, 1] },
      { start: [4, 1], end: [4, 2] },
      { start: [4, 2], end: [3, 3] },
      { start: [3, 3], end: [1, 3] },
      { start: [1, 3], end: [0, 2] },
      { start: [0, 2], end: [0, 1] },
      { start: [0, 1], end: [1, 0] },
      { start: [1, 3], end: [0, 4] },
      { start: [0, 4], end: [0, 6] },
      { start: [0, 6], end: [1, 7] },
      { start: [1, 7], end: [3, 7] },
      { start: [3, 7], end: [4, 6] },
      { start: [4, 6], end: [4, 4] },
      { start: [4, 4], end: [3, 3] },
    ],
    width: 5,
  });

  // 9
  map.set("9", {
    segments: [
      { start: [4, 3], end: [1, 3] },
      { start: [1, 3], end: [0, 2] },
      { start: [0, 2], end: [0, 1] },
      { start: [0, 1], end: [1, 0] },
      { start: [1, 0], end: [3, 0] },
      { start: [3, 0], end: [4, 1] },
      { start: [4, 1], end: [4, 6] },
      { start: [4, 6], end: [3, 7] },
      { start: [3, 7], end: [1, 7] },
    ],
    width: 5,
  });

  // . (period)
  map.set(".", {
    segments: [{ start: [1, 7], end: [1, 7] }],
    width: 2,
  });

  // , (comma)
  map.set(",", {
    segments: [{ start: [1, 6], end: [1, 8] }],
    width: 2,
  });

  return map;
};

const vectorFont: VectorFont = {
  characters: createCharacterMap(),
  height: FONT_HEIGHT,
  spacing: FONT_SPACING,
};

export default vectorFont;
export type { LineSegment, VectorCharacter, VectorFont };
